import React from "react";

import { SonicTopicsData } from "../../../common/classes/SonicTopics";
import NoResults from "../../../common/NoResults";
import ActionBtn from "../../../common/management/ActionBtn";

import {
  checkForJikeiRoles,
  timestampToTime,
} from "../../../utils/GeneralUtils";

import styles from "../../management/db-list/DBList.module.scss";

type Props = {
  topics: Array<SonicTopicsData>;
  authors?: Array<{ name: string; email: string; roles: Array<string> }>;
};

const ReleaseTopicsList: React.FC<Props> = ({ topics, authors }) => {
  if (topics.length === 0) return <NoResults />;

  return (
    <div className={styles["f-dbList"]}>
      <div
        className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["release"]}`}
      >
        <div>トピックス名</div>
        <div>カテゴリ</div>
        <div>作成者名</div>
        <div>掲載開始日</div>
        <div>アクション</div>
      </div>
      {topics?.map((topic, i) => (
        <div
          className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["release"]}`}
          key={i}
        >
          <div>{topic.name}</div>
          <div>{topic.topic_type?.name}</div>
          <div>
            {authors &&
            authors.length > 0 &&
            checkForJikeiRoles(authors[i].roles) ? (
              <span className={styles["userType"]}>滋</span>
            ) : null}
            {topic.author_name}
          </div>
          <div>{timestampToTime(topic.start_date, false)}</div>
          <div className={styles["f-dbList__category-body__action"]}>
            <ActionBtn
              label="対応する"
              icon={["fal", "edit"]}
              link={`/admin/topics/release/${topic.id}`}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReleaseTopicsList;
